import Session from './session'

export default class CompanyAPI {

  static get PREFIX () {
    return Session.HOST + '/api/company/'
  }

  /**
  * 既存チェック
  */
  static isExists (domain) {
    const s = new Session()
    return s.ins.post(CompanyAPI.PREFIX + 'is-exists', {domain: domain})
      .then(res => {
        // success
        return res
      })
      .catch(error => {
        // error
        return Promise.reject(error || 'ERROR')
      })
  }

  /**
  * 企業取得
  */
  static get () {
    const s = new Session()
    return s.ins.get(CompanyAPI.PREFIX + 'get')
      .then(res => {
        // success
        return res
      })
      .catch(error => {
        // error
        return Promise.reject(error || 'ERROR')
      })
  }

  /**
  * 企業一覧取得
  */
  static list (params) {
    const s = new Session()
    return s.ins.get(CompanyAPI.PREFIX + 'list', {params: params})
      .then(res => {
        // success
        return res
      })
      .catch(error => {
        // error
        return Promise.reject(error || 'ERROR')
      })
  }


  /**
  * 企業一覧取得
  */
  static report (companyId, params) {
    const s = new Session()
    return s.ins.get(CompanyAPI.PREFIX + 'report/' + companyId,  {params: params})
      .then(res => {
        // success
        return res
      })
      .catch(error => {
        // error
        return Promise.reject(error || 'ERROR')
      })
  }

  /**
  * 企業更新
  */
  static update (data) {
    const s = new Session()
    return s.ins.post(CompanyAPI.PREFIX + 'update', data)
      .then(res => {
        // success
        return res
      })
      .catch(error => {
        // error
        return Promise.reject(error || 'ERROR')
      })
  }

  /**
  * 企業削除（テスト用）
  */
  static delete (id) {
    const s = new Session()
    return s.ins.delete(CompanyAPI.PREFIX + 'delete/' + id)
      .then(res => {
        // success
        return res
      })
      .catch(error => {
        // error
        return Promise.reject(error || 'ERROR')
      })
  }

  /**
  * 企業退会
  */
  static signOut (id) {
    const s = new Session()
    return s.ins.delete(CompanyAPI.PREFIX + 'sign-out/' + id)
      .then(res => {
        // success
        return res
      })
      .catch(error => {
        // error
        return Promise.reject(error || 'ERROR')
      })
  }

  /**
  * クレジットカード更新
  */
  static updateCreditCard (data) {
    const s = new Session()
    return s.ins.post(CompanyAPI.PREFIX + 'update/creditCard', data)
      .then(res => {
        // success
        return res
      })
      .catch(error => {
        // error
        return Promise.reject(error || 'ERROR')
      })
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/api/company-api.js